import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getEducationLevels } from "./Axios";

const EducationLevelSelect = props => {
  const [education_levels, setEducationLevels] = useState([]);

  const handleChange = selectedOption => {
    props.handleChange(selectedOption, "education_level");
  };

  useEffect(() => {
    getEducationLevels((response) => {
      if (response && response.data) {
        const newEducationLevels = response.data.map((education_level) => ({
          value: education_level.id,
          label: education_level.name,
          uniqueIdentifier: education_level.unique_identifier,
        }));
        setEducationLevels(newEducationLevels);
      }
    });
  }, []);

  return (
    <Select
      inputId="trabajando-education-level-search"
      onChange={handleChange}
      options={education_levels}
      placeholder="Buscar y seleccionar nivel académico"
      value={
        education_levels.find(
          (option) => option.value === props.value?.value
        ) || null
      }
      getOptionLabel={(e) => `${e.label}`}
      filterOption={(option, input) => {
        const searchTerm = input.toLowerCase();
        const { label } = option.data;
        return (
          label.toLowerCase().includes(searchTerm)
        );
      }}
      isSearchable={true}
    />
  );
};

export default EducationLevelSelect;

